import { css } from "styled-components";
import token from "styled-token";
import { alphaMixin } from "../alphaMixin";
import { spaceMixin } from "../spaceMixin";
import { StyledTab } from "../../components/Tabs/Tab";
import { TABS_APPEARANCES } from "../../constants/TABS";

var defaultTabCSS = function defaultTabCSS(props) {
  return token({
    borderWidth: "Button.borderWidth",
    borderColor: "colors.gray300",
    fontColorHover: "colors.brand",
    indicatorBorderRadius: "Button.borderRadius",
    selectedTabIndicatorColor: "Tabs.selectedTabIndicatorColor",
    selectedTabIndicatorHeight: "Tabs.selectedTabIndicatorHeight"
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
        borderColor = _ref.borderColor,
        fontColorHover = _ref.fontColorHover,
        indicatorBorderRadius = _ref.indicatorBorderRadius,
        selectedTabIndicatorColor = _ref.selectedTabIndicatorColor,
        selectedTabIndicatorHeight = _ref.selectedTabIndicatorHeight;
    return css(["border-bottom:", "px solid ", ";", "{position:relative;background-color:transparent;border:0;padding:", ";transition:flex-shrink 0.2s ease-out;&:hover:not(:disabled),&:active:not(:disabled){background-color:transparent;color:", ";}&[aria-selected=\"true\"]{background-color:transparent;padding:", ";}&[aria-selected=\"true\"]:before{background-color:", ";border-radius:", "px ", "px 0 0;bottom:0;content:\"\";display:block;height:", "px;left:0;position:absolute;width:100%;}}"], borderWidth, borderColor, StyledTab, spaceMixin("sm")(props), fontColorHover, spaceMixin("sm")(props), selectedTabIndicatorColor, indicatorBorderRadius, indicatorBorderRadius, selectedTabIndicatorHeight);
  })(props);
};

var fileTabCSS = function fileTabCSS(props) {
  return token({
    backgroundColor: "Button.tertiary.backgroundColor",
    backgroundColorSelected: "Button.tertiary.backgroundColor",
    borderColorSelected: "Button.tertiary.borderColor",
    borderRadius: "Button.borderRadius",
    borderWidth: "Button.borderWidth",
    borderWidthSelected: "Button.borderWidth",
    indicatorWidth: "Tabs.selectedTabIndicatorHeight",
    selectedTabIndicatorColor: "Tabs.selectedTabIndicatorColor",
    selectedTabIndicatorHeight: "Tabs.selectedTabIndicatorHeight",
    tabPadding: "spacing.sm"
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        backgroundColorSelected = _ref2.backgroundColorSelected,
        borderColorSelected = _ref2.borderColorSelected,
        borderRadius = _ref2.borderRadius,
        borderWidth = _ref2.borderWidth,
        borderWidthSelected = _ref2.borderWidthSelected,
        indicatorWidth = _ref2.indicatorWidth,
        selectedTabIndicatorColor = _ref2.selectedTabIndicatorColor,
        selectedTabIndicatorHeight = _ref2.selectedTabIndicatorHeight,
        tabPadding = _ref2.tabPadding;
    return css(["", "", "{border-radius:", "px ", "px 0 0;padding:", ";transition:flex-shrink 0.2s ease-out;&:hover:not(:disabled):before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );transition:background 0s;}&:active:not(:disabled):before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );}&[aria-selected=\"true\"]{background-color:", ";border-color:", ";border-width:", "px;border-bottom-color:", ";border-top-color:", ";border-top-width:", "px;padding-top:", "px;}}"], StyledTab, StyledTab, borderRadius, borderRadius, spaceMixin("sm")(props), alphaMixin("gray200", 0)(props), alphaMixin("gray200", 1)(props), alphaMixin("gray200", 1)(props), alphaMixin("gray300", 0)(props), alphaMixin("gray300", 1)(props), alphaMixin("gray300", 1)(props), backgroundColorSelected, borderColorSelected, borderWidthSelected, backgroundColor, selectedTabIndicatorColor, selectedTabIndicatorHeight, tabPadding - indicatorWidth + borderWidth);
  })(props);
};

var fluidTabCSS = function fluidTabCSS(_ref3) {
  var fluid = _ref3.fluid;

  if (!fluid) {
    return "";
  }

  return "\n        " + StyledTab + " {\n            flex-basis: 0; /* All tabs display equal width */\n            flex-grow: 1;\n            justify-content: center;\n\n            &:before {\n                display: none;\n            }\n        }\n    ";
};

var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;

  switch (appearance) {
    case TABS_APPEARANCES.file:
      return fileTabCSS(props);

    default:
      return defaultTabCSS(props);
  }
};
/** @class TabListMixin */

/** @method */


export var TabListMixin = function TabListMixin(props) {
  return css(["display:flex;margin-bottom:-", "px;", " ", ""], token("Button.borderWidth")(props), appearanceCSS(props), fluidTabCSS(props));
};